import { productEnabled } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';

export default {
  peopleSearch: hosts => hosts.perform && productEnabled('connect') && {
    id: 'SECONDARY_COMPANY_PEOPLE_SEARCH',
    host: hosts.perform,
    href: '/connect/search',
    name: I18n.t('People Search'),
  },
  orgChart: (hosts, user) => hosts.perform && productEnabled('connect') && {
    id: 'SECONDARY_COMPANY_ORG_CHART',
    host: hosts.perform,
    href: `/connect/org-chart/${user.id}`,
    name: I18n.t('Org Chart'),
  },
  goals: hosts => hosts.perform && productEnabled('perform') && {
    id: 'SECONDARY_COMPANY_GOALS',
    host: hosts.perform,
    href: '/talent/company-goals',
    name: I18n.t('Goals'),
    okrName: I18n.t('Objectives'),
  },
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/company.js